import { render, staticRenderFns } from "./ScrollWallTheme.vue?vue&type=template&id=3f0a2133&scoped=true"
import script from "./ScrollWallTheme.vue?vue&type=script&lang=js"
export * from "./ScrollWallTheme.vue?vue&type=script&lang=js"
import style0 from "./ScrollWallTheme.vue?vue&type=style&index=0&id=3f0a2133&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0a2133",
  null
  
)

export default component.exports